import { useMemo } from 'react';

export const useTextFilter = (sortedText) => {
  const isRevisionDone = (text) =>
    text.revisionDone === true &&
    text.validated === false &&
    ((text.globalRevisionSent === true && text.revisionSent === false) ||
      text.revisionSent === true);

  const isRevisionSent = (text) =>
    text &&
    ((text.globalRevisionSent === true && text.revisionDone === false) ||
      (text.revisionSent === true &&
        text.revisionDone === false &&
        text.validated === false));

  const isDraft = (text) =>
    text &&
    text.globalRevisionSent === false &&
    text.revisionSent === false &&
    text.revisionDone === false &&
    text.validated === false &&
    text.delivered === false;

  const isDelivered = (text) =>
    text &&
    text.globalRevisionSent === false &&
    text.revisionSent === false &&
    text.revisionDone === false &&
    text.validated === false &&
    text.delivered === true;

  const isValidated = (text) => text && text.validated;

  const isTextEligibleForValidation = (text) =>
    isDelivered(text) || isRevisionDone(text);

  const isTextEligibleForValidationAndRevision = (text, orderType) =>
    isTextEligibleForRevision(text, orderType);

  const isTextEligibleForDelivery = (text) => isDraft(text);

  const isTextEligibleToReputInDraft = (text) =>
    isDelivered(text) &&
    !isValidated(text) &&
    !isRevisionSent(text) &&
    !isRevisionDone(text);

  const isTextEligibleForRevision = (text, orderType) =>
    isDelivered(text) &&
    !isRevisionSent(text) &&
    !isRevisionDone(text) &&
    !isValidated(text) &&
    availbleRevisionNumber > 0 &&
    orderType !== 'SMART';

  const getAvailableTextsCount = (texts) =>
    texts.filter(
      (text) =>
        !text.revisionSent &&
        !text.globalRevisionSent &&
        !text.validated &&
        !text.revisionDone &&
        text.delivered
    ).length;

  const availbleRevisionNumber = useMemo(
    () => getAvailableTextsCount(sortedText),
    [sortedText]
  );

  const availableRedraftingNumber = useMemo(
    () => getAvailableTextsCount(sortedText),
    [sortedText]
  );

  const availableValidationNumber = useMemo(
    () => sortedText.filter((text) => isTextEligibleForValidation(text)).length,
    [sortedText]
  );

  const availableDeliveryNumber = useMemo(
    () => sortedText.filter((text) => isDraft(text)).length,
    [sortedText]
  );

  const isAllTextesDelivered = (sortedText) => {
    if (sortedText.length === 0) return false;
    return sortedText.every((text) => text.delivered);
  };

  const isTranslateOnly = useMemo(
    () =>
      Boolean(sortedText.filter((text) => text.type === 'TRANSLATED').length),
    [sortedText]
  );

  const isTextOnly = useMemo(
    () =>
      Boolean(
        sortedText.filter((text) => text.type === 'NON_TRANSLATED').length
      ),
    [sortedText]
  );

  const isCombined = useMemo(
    () => Boolean(sortedText.filter((text) => text.type === 'COMBINED').length),
    [sortedText]
  );

  return {
    availbleRevisionNumber,
    availableValidationNumber,
    availableDeliveryNumber,
    availableRedraftingNumber,
    isTextEligibleForValidation,
    isTextEligibleForDelivery,
    isTextEligibleForRevision,
    isTextEligibleToReputInDraft,
    isTextEligibleForValidationAndRevision,
    isTranslateOnly,
    isTextOnly,
    isCombined,
    isRevisionDone,
    isRevisionSent,
    isDraft,
    isDelivered,
    isValidated,
    isAllTextesDelivered,
  };
};
